import React from "react";
import "../../css/Actions.css";

const Actions = ({ onConfirm, onBack, disabled}) => {
  return (
    <>
    <div className="summary-actions">
      <button onClick={onBack}>Wstecz</button>
      <button onClick={onConfirm} disabled={disabled}>Zatwierdź</button>
    </div>
     </>
  );
};

export default Actions;
